import { Alert, Input } from '@piggytechng/component-library';
import { OverideInputStyle } from '../../helpers/utils';
import { useEffect, useState } from 'react';
import { IoEyeSharp } from 'react-icons/io5';
import { FaEyeSlash } from 'react-icons/fa';
import { verifyAdminPassword } from '../../helpers/utils/auth-payload';

const ModalChildren = ({ isLoading, setIsOpen, modalIsOpen, action, closeModal, actionColor, text }: any) => {
  const onButtonClick = async (e: { preventDefault: () => void }) => {
    e.preventDefault();

    if (password === '') {
      Alert.error('Please enter your password to proceed!');
      return;
    }

    setIsVerifying(true);
    const verified = await verifyAdminPassword(password);
    setIsVerifying(false);

    if (!verified) return;

    action(password);
  };

  useEffect(() => {
    setPassword('');
  }, [modalIsOpen]);

  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);

  const busy = isLoading || isVerifying;

  return (
    <div className={`modal-base general success action flex--4`}>
      <span onClick={closeModal}>&times;</span>
      <form>
        <h4>Are you sure you want to {text}</h4>

        <div className="input-cont flex--2">
          <Input
            {...OverideInputStyle}
            label="Input Password "
            className="user-form-input"
            height="60px"
            placeholder="123456"
            type={showPassword ? 'text' : 'password'}
            onChange={(e) => {
              e.preventDefault();
              setPassword(e.target.value);
            }}
            id="password"
            name="password"
            value={password}
          />
          {!showPassword ? (
            <div className="password-icon pointer" onClick={() => setShowPassword(!showPassword)}>
              <IoEyeSharp size={20} />
            </div>
          ) : (
            <div className="password-icon pointer" onClick={() => setShowPassword(!showPassword)}>
              <FaEyeSlash size={20} />
            </div>
          )}
        </div>

        <div className="button-cont flex--2">
          <button
            type="button"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Cancel
          </button>

          <button onClick={onButtonClick} disabled={busy} style={{ backgroundColor: actionColor }}>
            {busy ? 'Loading...' : 'Yes'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ModalChildren;
